import { render, staticRenderFns } from "./photoAlbum.vue?vue&type=template&id=3ae81d97&scoped=true"
import script from "./photoAlbum.vue?vue&type=script&lang=js"
export * from "./photoAlbum.vue?vue&type=script&lang=js"
import style0 from "./photoAlbum.vue?vue&type=style&index=0&id=3ae81d97&prod&lang=scss&scoped=true"
import style1 from "./photoAlbum.vue?vue&type=style&index=1&id=3ae81d97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae81d97",
  null
  
)

export default component.exports